<template>
    <form class="form comment-form-wrapper" @submit.prevent="handleSubmit" novalidate>
        <div class="comment-form">
            <img
                :src="`/images/avatar/${user.id}`"
                alt=""
                class="avatar"
                v-if="user"
            />
            <TextareaWithMentions
                ref="commentContent"
                v-model="formData.message"
            />
            <button class="btn btn--icon btn--primary" :disabled="$wait.is('processing')">
                <Spinner v-if="$wait.is('processing')"/>
                <SvgIcon v-else icon="filled-send" classes="filled" />
            </button>
        </div>
    </form>
</template>
<script>
import { mapState } from 'vuex';
import SvgIcon from '@components/SvgIcon';
import TextareaWithMentions from '@components/Form/TextareaWithMentions';
import API from '@api';
import Spinner from '@components/Spinner.vue';

export default {
    name: "SectorPostCardCommentForm",
    components: {
        Spinner,
        TextareaWithMentions,
        SvgIcon,
    },
    props: {
        postId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            formData: {
                message: null,
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },
    methods: {
        async handleSubmit() {
            try {
                this.$wait.start('processing');
                await API.addSectorPostComment(this.postId, this.formData);

                if(this.$refs.commentContent) {
                    this.$refs.commentContent.reset();
                }

                this.$emit('comment-added');
            } catch(err) {
                console.warn({err});
            } finally {
                this.$wait.end('processing');
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/theme/_variables.scss";

    .comment-form-wrapper {
        padding: 1.5rem 2rem;
        border-top: .1rem solid $border;
    }

    .comment-form {
        position: relative;
        display: flex;
        align-items: flex-start;
        padding-right: 1.7rem;

        .avatar {
            height: 3.6rem;
            width: 3.6rem;
        }

        .btn {
            position: absolute;
            top: 0;
            right: 0;
        }
    }
</style>
